// The only file that talks to the server about pinned records (C315, X7-11b). The list is saved in the person's own
// preferences (PERSON_PREFS.favourites, /me/prefs), so it follows the person to other devices.
import { call } from "@/data/server-client";
import type { RecordRef } from "@/features/search/recordIndex";

/** The pins saved for this person: the `favourites` value of GET /me/prefs, or undefined when nothing was ever saved. */
export async function readServerFavourites(): Promise<unknown> {
  const prefs = await call<{ favourites?: unknown }>("/me/prefs");
  return prefs.favourites;
}

/** Saves the whole list. The server refuses more than 40 entries or a bad entry (422); the caller keeps the browser copy either way. */
export async function writeServerFavourites(list: RecordRef[]): Promise<void> {
  await call("/me/prefs/favourites", { method: "PUT", body: JSON.stringify(list) });
}
